import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { defineComponent, ref } from 'vue';
import HeaderLoyaltyButton from '@/components/layout/next/parts/Loyalty/HeaderLoyaltyButton.vue';
import { ContactsButton } from '@/entities/manager/ui';
import { CertifiedPartner } from '@/features/certified-partner/ui';
import LoyaltyMenuItem from '@/features/loyalty/ui/LoyaltyMenuItem.vue';
import { HeaderProfileButton } from '@/features/user-profile';
import { useModalHandler } from '@/plugins/modal';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { useElementHeight } from '@/shared/composables';
import { ROUTE_PATHS } from '@/shared/constants';
import { NavButton, TheLogo } from '@/shared/ui';
import { useAuthStore } from '@/store/authStore';
import { FLAGS, useFeatureFlagsStore } from '@/store/featureFlags';
import { useGlobalStore } from '@/store/global';
import { useMenuStore } from '@/store/menu';
import HeaderButtonMenu from './HeaderButtonMenu.vue';
import HeaderNotificationsButton from './HeaderNotificationsButton.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizedHeader',
  emits: ["menu-button-click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'AuthorizedHeader'
    });
    var headerRef = ref(null);
    var headerHeight = useElementHeight(headerRef);
    var globalStore = useGlobalStore();
    var globalInit = globalStore.globalInit;
    var screen = useScreenPlugin();
    var _useMenuStore = useMenuStore(),
      getMenu = _useMenuStore.getMenu;
    onBeforeMount(function () {
      globalInit();
      getMenu();
    });
    var $modal = useModalHandler();
    var featureFlagsStore = useFeatureFlagsStore();
    var hasSupportFlag = featureFlagsStore.isEnabledFlag(FLAGS.support);
    var isHeaderNew = featureFlagsStore.isHeaderNew();
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      isAggregator = _storeToRefs.isAggregator;
    var handleSupport = function handleSupport() {
      $modal.open({
        component: 'ModalTechSupport',
        overlay: false,
        transition: null
      });
    };
    return {
      __sfc: true,
      emit: emit,
      headerRef: headerRef,
      headerHeight: headerHeight,
      globalStore: globalStore,
      globalInit: globalInit,
      screen: screen,
      getMenu: getMenu,
      $modal: $modal,
      featureFlagsStore: featureFlagsStore,
      hasSupportFlag: hasSupportFlag,
      isHeaderNew: isHeaderNew,
      authStore: authStore,
      isAggregator: isAggregator,
      handleSupport: handleSupport,
      HeaderLoyaltyButton: HeaderLoyaltyButton,
      ContactsButton: ContactsButton,
      CertifiedPartner: CertifiedPartner,
      LoyaltyMenuItem: LoyaltyMenuItem,
      HeaderProfileButton: HeaderProfileButton,
      ROUTE_PATHS: ROUTE_PATHS,
      NavButton: NavButton,
      TheLogo: TheLogo,
      HeaderButtonMenu: HeaderButtonMenu,
      HeaderNotificationsButton: HeaderNotificationsButton
    };
  }
});